import { jsx as _jsx } from "react/jsx-runtime";
const colorMap = {
    primary: 'var(--color-text)',
    muted: 'var(--color-text-muted)',
    faint: 'var(--color-text-faint)',
    accent: 'var(--color-accent)',
    success: 'var(--color-success)',
    warning: 'var(--color-warning)',
    danger: 'var(--color-danger)',
    inverse: 'var(--color-text-inverse)',
};
const sizeMap = {
    xs: 'var(--font-size-xs)',
    sm: 'var(--font-size-sm)',
    base: 'var(--font-size-base)',
    md: 'var(--font-size-md)',
    lg: 'var(--font-size-lg)',
    xl: 'var(--font-size-xl)',
    '2xl': 'var(--font-size-2xl)',
    '3xl': 'var(--font-size-3xl)',
};
const weightMap = {
    light: 'var(--font-weight-light)',
    regular: 'var(--font-weight-regular)',
    medium: 'var(--font-weight-medium)',
};
const trackingMap = {
    tight: 'var(--letter-spacing-tight)',
    normal: 'var(--letter-spacing-normal)',
    wide: 'var(--letter-spacing-wide)',
    wider: 'var(--letter-spacing-wider)',
    widest: 'var(--letter-spacing-widest)',
};
const headingSizeDefaults = {
    1: '3xl', 2: '2xl', 3: 'xl', 4: 'lg', 5: 'md', 6: 'base',
};
export function Heading({ level = 2, size, weight = 'medium', color = 'primary', tracking, truncate, as, style, children, ...rest }) {
    const Tag = as ?? `h${level}`;
    const resolvedSize = size ?? headingSizeDefaults[level];
    const s = {
        fontFamily: 'var(--font-family)',
        fontSize: sizeMap[resolvedSize],
        fontWeight: weightMap[weight],
        lineHeight: 'var(--line-height-tight)',
        color: colorMap[color],
        letterSpacing: tracking ? trackingMap[tracking] : undefined,
        ...(truncate && {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }),
        ...style,
    };
    return _jsx(Tag, { style: s, ...rest, children: children });
}
export function Text({ as: Tag = 'p', size = 'base', weight = 'regular', color, muted, faint, truncate, lineClamp, style, children, ...rest }) {
    let resolvedColor = color ?? 'primary';
    if (muted)
        resolvedColor = 'muted';
    if (faint)
        resolvedColor = 'faint';
    const s = {
        fontFamily: 'var(--font-family)',
        fontSize: sizeMap[size],
        fontWeight: weightMap[weight],
        lineHeight: 'var(--line-height-normal)',
        color: colorMap[resolvedColor],
        ...(truncate && {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }),
        ...(lineClamp && {
            display: '-webkit-box',
            WebkitLineClamp: lineClamp,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        }),
        ...style,
    };
    return _jsx(Tag, { style: s, ...rest, children: children });
}
export function Label({ color = 'muted', htmlFor, style, children, ...rest }) {
    const s = {
        fontFamily: 'var(--font-family)',
        fontSize: 'var(--font-size-xs)',
        fontWeight: 'var(--font-weight-medium)',
        lineHeight: 'var(--line-height-normal)',
        color: colorMap[color],
        textTransform: 'uppercase',
        letterSpacing: 'var(--letter-spacing-widest)',
        ...style,
    };
    if (htmlFor) {
        return _jsx("label", { htmlFor: htmlFor, style: s, ...rest, children: children });
    }
    return _jsx("span", { style: s, ...rest, children: children });
}
export function Code({ style, children, ...rest }) {
    const s = {
        fontFamily: 'var(--font-family)',
        fontSize: 'var(--font-size-sm)',
        lineHeight: 'var(--line-height-normal)',
        backgroundColor: 'var(--color-surface-sunken)',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-md)',
        padding: '0.1em 0.4em',
        ...style,
    };
    return _jsx("code", { style: s, ...rest, children: children });
}
